import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=4b83dac6&"
import script from "./WishList.vue?vue&type=script&lang=js&"
export * from "./WishList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports